module.exports = __webpack_public_path__ + "img/no_data.5e00b2ed.png";